import React, { useState, useEffect } from 'react';
import { useAuth } from 'oidc-react';
import { APIHandler, StorageHandler } from 'C4';
import { baseAppId, storageKeys } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const SSOView = () => {
  const [logo, setLogo] = useState(null);
  const auth = useAuth();

  const getAppInfo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setLogo(appInfo.logo);
    }
  };

  useEffect(() => {
    // Function to handle the authentication process and redirect accordingly
    const handleAuthentication = async () => {
      if (process.env.NODE_ENV === 'development') {
        const savedRoute = localStorage.getItem('savedRoute');
        window.location.href = savedRoute || '/main';
      }

      if (auth && auth.userData && auth.userData.profile) {
        try {
          console.log(auth, auth.userData, auth.userData.profile.name, auth.userData);
          const email = auth.userData.email ? auth.userData.email : auth.userData.profile.email;

          // Always create user, with data from quark
          await APIHandler.registerUserProgress(email);

          const profile = auth.userData.profile;
          console.log(profile);

          const country = profile['https://www.quarkexpeditions.com/country'] || '';
          const idNumber = profile['https://www.quarkexpeditions.com/iataCliaNumber'] || '';
          const state = profile['https://www.quarkexpeditions.com/state'] || '';
          const title = profile['https://www.quarkexpeditions.com/role'] || '';
          const agencyName = profile['https://www.quarkexpeditions.com/travelAgency'] || '';
          const firstName = profile['https://www.quarkexpeditions.com/firstName'] || '';
          const lastName = profile['https://www.quarkexpeditions.com/lastName'] || '';

          const userInput = {
            email,
            first_name: firstName,
            last_name: lastName,
            agency_name: agencyName,
            state,
            country,
            title,
            id_number: idNumber,
          };

          if (
            userInput.email &&
            userInput.email.trim() !== '' &&
            userInput.firstName &&
            userInput.firstName.trim() !== '' &&
            userInput.lastName &&
            userInput.lastName.trim() !== '' &&
            userInput.agencyName &&
            userInput.agencyName.trim() !== '' &&
            userInput.state &&
            userInput.state.trim() !== '' &&
            userInput.country &&
            userInput.country.trim() !== ''
          ) {
            console.log('Profile not complete');
            const userInfo = await APIHandler.getUser(baseAppId, email);
            if (APIHandler.ok(userInfo.response)) {
              if (userInfo.response.sales_companion_registered) {
                // Successfully logged in + complete profile
                const { year } = StorageHandler.expire;
                StorageHandler.save(storageKeys.user, userInfo, year);

                const savedRoute = localStorage.getItem('savedRoute');
                if (
                  savedRoute !== null &&
                  savedRoute !== '/login' &&
                  savedRoute !== '/logout' &&
                  savedRoute !== '/register' &&
                  savedRoute !== '/sso' &&
                  savedRoute !== '/[object%20Object]' &&
                  savedRoute !== '/[object Object]'
                ) {
                  setTimeout(() => {
                    window.location.href = savedRoute; // Redirect to the saved route
                  }, 5000);
                } else {
                  setTimeout(() => {
                    window.location.href = '/main';
                  }, 5000);
                }
                return;
              }

              // Profile not complete
              window.location.href = '/register';
              return;
            }

            // Profile not complete
            window.location.href = '/register';
            return;
          }

          await APIHandler.setUser(userInput.email, baseAppId, userInput);
          const userInfo = await APIHandler.getUser(baseAppId, email);
          if (APIHandler.ok(userInfo.response)) {
            console.log('Profile complete');

            // Check if all required fields are set
            const { email, state } = userInfo.response;
            const firstName = userInfo.response.first_name;
            const lastName = userInfo.response.last_name;
            const agencyName = userInfo.response.agency_name;
            const country = userInfo.response.country;

            // Successfully logged in + complete profile
            const { year } = StorageHandler.expire;
            StorageHandler.save(storageKeys.user, userInfo, year);

            const savedRoute = localStorage.getItem('savedRoute');
            if (
              savedRoute !== null &&
              savedRoute !== '/login' &&
              savedRoute !== '/logout' &&
              savedRoute !== '/register' &&
              savedRoute !== '/sso' &&
              savedRoute !== '/[object%20Object]' &&
              savedRoute !== '/[object Object]'
            ) {
              setTimeout(() => {
                window.location.href = savedRoute; // Redirect to the saved route
              }, 5000);
            } else {
              setTimeout(() => {
                window.location.href = '/main';
              }, 5000);
            }
          } else {
            // Not in TravPRO system, register (shouldn't be possible)
            window.location.href = '/register';
          }
        } catch (error) {
          console.error('Error while fetching user data:', error);
          // Handle the error accordingly (e.g., show an error message or redirect to login page)
          window.location.href = '/login';
        }
      } else {
        setTimeout(() => {
          toast.error(
            "Login failed, please try to log out and log back in. If this doesn't resolve your issue, please contact support at info@travpromobile.com.",
            {
              position: 'bottom-center',
              transition: Zoom,
              autoClose: 10000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            },
          );
        }, 10000);

        setTimeout(() => {
          window.location.href = '/login';
        }, 15000);
      }
    };

    getAppInfo();
    handleAuthentication();
  }, [auth]);

  return (
    <div className="magicLinkView">
      <div className="sso-bg" />
      <ToastContainer />
      <div className="sso-content">
        {logo && <img src={logo} className="logo" alt="Logo" />}
        <span className="spinner">
          <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
        </span>
        <p>Please wait, we are signing you in right now.</p>
      </div>
    </div>
  );
};

export default SSOView;
